import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María', 'Camila', 'Valentina', 'Sofía', 'Isabella', 'Daniela', 'Mariana', 'Gabriela', 'Andrea', 'Carolina', 'Laura', 'Natalia', 'Alejandra', 'Paola', 'Juliana', 'Catalina', 'Diana', 'Lorena', 'Mónica', 'Claudia', 'Ana', 'Lucía', 'Sara', 'Paula', 'Fernanda'];
const cities = ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena', 'Buenos Aires', 'CDMX', 'Lima', 'Santiago', 'Quito', 'Miami', 'Madrid', 'Barcelona', 'Cancún', 'San José'];
export function SalesNotification() {
  const [show, setShow] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  const pickRandom = useCallback(() => {
    setData({
      name: names[Math.floor(Math.random() * names.length)],
      city: cities[Math.floor(Math.random() * cities.length)]
    });
  }, []);
  useEffect(() => {
    // Check if mobile
    const checkMobile = () => window.innerWidth <= 768;
    if (!checkMobile()) return;
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const cycle = () => {
      if (!checkMobile()) return;
      pickRandom();
      setShow(true);
      hideTimeout = setTimeout(() => {
        setShow(false);
        // Random interval between 5-10 seconds
        const nextDelay = 5000 + Math.random() * 5000;
        showTimeout = setTimeout(cycle, nextDelay);
      }, 2000);
    };
    // First appearance after 4 seconds
    showTimeout = setTimeout(cycle, 4000);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [pickRandom]);
  return <AnimatePresence data-id="element-275" data-mp="2s6uf49fkb4a8">
      {show && <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 10,
      scale: 0.98
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25,
      mass: 0.8
    }} className="fixed bottom-20 left-3 right-3 z-[60] md:hidden pointer-events-none" data-id="element-276" data-mp="11t3oz8z6vlsp">
          <div className="mx-auto max-w-sm rounded-2xl px-3.5 py-3 flex items-center gap-3 border border-white/20" style={{
        background: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        boxShadow: '0 4px 30px rgba(0,0,0,0.12), 0 1px 3px rgba(0,0,0,0.08)'
      }} data-id="element-277" data-mp="3brzini2ps9c3">
            {/* Product image */}
            <div className="flex-shrink-0 w-11 h-11 rounded-xl overflow-hidden shadow-sm" data-id="element-278" data-mp="3g3py25wodl9">
              <img src="https://cdn.magicpatterns.com/uploads/iwry5jWpKzBng5LRuRN5Xg/HERO_SECTION.webp" alt="eBook" className="w-full h-full object-cover" data-id="element-279" data-mp="7gds13qkujuu" />
            </div>

            {/* Text content */}
            <div className="flex-1 min-w-0" data-id="element-280" data-mp="1iwf4yinu72oy">
              <p className="text-[13px] text-gray-900 leading-tight" style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif'
          }} data-id="element-281" data-mp="1izb1c2k1djba">
                <span className="font-semibold" data-id="element-282" data-mp="26o3yu3gb3z80">{data.name}</span>
                <span className="text-gray-500" data-id="element-283" data-mp="21vj8xd0iu69r"> de {data.city}</span>
              </p>
              <p className="text-[12px] text-gray-500 leading-tight mt-0.5" style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif'
          }} data-id="element-284" data-mp="1wx9dr2esr5o5">
                Compró{' '}
                <span className="font-medium text-gray-700" data-id="element-285" data-mp="2a3vr5bos2d9i">
                  Espacios Sagrados
                </span>{' '}
                · <span className="font-semibold text-gray-900" data-id="element-286" data-mp="2e6a97tkmh8zq">$14.99</span>
              </p>
            </div>

            {/* Time indicator */}
            <span className="text-[11px] text-gray-400 flex-shrink-0 self-start mt-0.5" style={{
          fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif'
        }} data-id="element-287" data-mp="207srccheeqpq">
              ahora
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}